import _find from 'lodash/find';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Readers
import filterTypeReader from '../../../readers/FilterType';
export var getFilterData = function getFilterData(selectedFilters) {
  var filterType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var filterId = filterTypeReader.id(filterType);
  var selectedFilter = _find(selectedFilters, {
    type: filterId
  });
  if (selectedFilter) {
    return {
      values: selectedFilter.values,
      additional: selectedFilter.additional
    };
  }
  return EMPTY_OBJECT;
};